<template>
  <div
    class="flex items-center gap-2 bg-gray-10"
    :class="{
      'p-2': size === 'lg',
      'p-1': size === 'sm',
    }"
  >
    <button :class="buttonClasses" @click="remove">
      <IconMinus :class="iconClasses" />
    </button>
    <input
      id="qty"
      v-model.number="value"
      type="text"
      :class="inputClasses"
      @keydown="isNumber($event)"
    />
    <button :class="buttonClasses" @click="add">
      <IconPlus :class="iconClasses" />
    </button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  minPurchase?: number | undefined
  maxPurchase?: number | undefined
  purchaseSteps?: number | undefined
  size: 'sm' | 'lg'
}>()

const value = defineModel<number>()

const isNumber = (event: KeyboardEvent) => {
  const keysAllowed = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'Delete',
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
  ]
  if (!keysAllowed.includes(event.key)) {
    event.preventDefault()
  }
}

const add = () => {
  if (!value.value) {
    value.value = props.minPurchase || 1
    return
  }
  if (props.maxPurchase && value.value >= props.maxPurchase) {
    return
  }
  value.value += 1
}

const remove = () => {
  if (!value.value) {
    value.value = props.minPurchase || 1
  }
  if (props.minPurchase && value.value <= props.minPurchase) {
    return
  }
  value.value -= 1
}

const inputClasses = computed(() => {
  const classes = ['bg-transparent text-center font-bold focus:outline-none']

  if (props.size === 'lg') {
    classes.push('text-base h-8 w-10')
  }

  if (props.size === 'sm') {
    classes.push('text-xs h-4 w-6')
  }

  return classes.join(' ')
})

const buttonClasses = computed(() => {
  const classes = [
    'flex items-center justify-center rounded-sm border border-gray-100 bg-white max-lg:border max-md:border-gray-500',
  ]

  if (props.size === 'lg') {
    classes.push('size-8')
  }

  if (props.size === 'sm') {
    classes.push('size-4')
  }

  return classes.join(' ')
})

const iconClasses = computed(() => {
  const classes = ['text-black']

  if (props.size === 'lg') {
    classes.push('w-4 lg:w-12')
  }

  if (props.size === 'sm') {
    classes.push('w-4')
  }

  return classes.join(' ')
})
</script>
